import React, { FC, ReactElement } from 'react';

import { TableDataNotFound, InfoCircle, Loader } from 'components';
import { IOrganizationHoldingToken } from 'types/interfaces';
import { useAppSelector } from 'store';
import { TOKEN_TAB, TOKEN_TAB_DESCRIPTIONS } from '../../../../../../../../constants';

import { RowItems, TableHeader } from './components';
import styles from './styles.module.scss';
import { TableProBlur } from '../../../OrganizationTreasury/components/DaoAssetsTable/components/TableProBlur';
import { organizationsMock } from './constants';

type OrganizationsHoldingTokenTableProps = {
    isPremiumAllowed: boolean;
};

export const OrganizationsHoldingTokenTable: FC<OrganizationsHoldingTokenTableProps> = ({
    isPremiumAllowed,
}): ReactElement => {
    const { organizationHoldingToken } = useAppSelector(({ organizationTabs }) => organizationTabs);

    const data = organizationHoldingToken?.data?.length ? organizationHoldingToken?.data : organizationsMock;
    return (
        <>
            <div className={styles.tableWrapper}>
                <div className={styles.titleWrapper}>
                    <h4 className={styles.tableTitle}>Organizations holding token</h4>
                    <InfoCircle
                        tooltipText={TOKEN_TAB_DESCRIPTIONS[TOKEN_TAB.ORGANIZATIONS_HOLDING_TOKEN]}
                        className={styles.infoIcon}
                    />
                </div>

                <div style={{ position: 'relative' }}>
                    {organizationHoldingToken.loading &&
                        organizationHoldingToken.data.length === 0 &&
                        isPremiumAllowed && (
                            <div className={styles.loaderBox}>
                                <Loader size={40} className={styles.similarUsersLoader} />
                            </div>
                        )}
                    {!organizationHoldingToken.loading && (
                        <div className={styles.dataContainer}>
                            <div className={styles.tableContainer}>
                                <TableHeader />
                                <div className={styles.rowsWrapper}>
                                    <div className={`${styles.rowsContainer} ${!isPremiumAllowed && styles.blur}`}>
                                        {data?.map((organization: IOrganizationHoldingToken) => (
                                            <RowItems key={organization.organization.id} {...organization} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {!organizationHoldingToken.loading &&
                        organizationHoldingToken.data.length === 0 &&
                        isPremiumAllowed && <TableDataNotFound forTable overflowMarginsSecondVariant />}
                    {!isPremiumAllowed && (
                        <div className={styles.blurWrapper}>
                            <TableProBlur
                                title="Organizations holding token is a DeepDAO Pro feature"
                                description={TOKEN_TAB_DESCRIPTIONS[TOKEN_TAB.ORGANIZATIONS_HOLDING_TOKEN]}
                            />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
